<template>
  <div
    v-if="
      insurance &&
      String(insurance).length > 0 &&
      reconciliationData &&
      reconciliationData.length > 0
    "
  >
    <v-card elevation="2">
      <v-row justify="space-between">
        <v-col cols="6" sm="8" class="py-0">
          <v-card-title primary-title
            >Reconciliation - {{ this.reportMode }}</v-card-title
          >
        </v-col>
        <v-col cols="6" sm="4" lg="2" class="py-0">
          <v-switch color="secondary" inset v-model="pmpm" class="float-right">
            <template slot="prepend">
              <p class="pt-1 mr-2">{{ this.toggleName }}</p>
            </template>
          </v-switch>
        </v-col>
      </v-row>
      <v-data-table
        :loading="load"
        :headers="headers"
        :items="reconciliationData"
        :search="search"
        :sort-desc="[true]"
        hide-default-footer
        multi-sort
        loading-text="Loading data..."
        class="elevation-0 col-md-12 m-auto"
      >
        <template
          v-if="reconciliationData &&reconciliationData.length > 0"
          v-slot:header="{ headers }"
        >
          <thead>
            <tr>
              <th v-for="header in headers">
                {{ header }}
              </th>
            </tr>
          </thead>
        </template>

        <template v-if="reconciliationData && reconciliationData.length > 0" v-slot:body="{ items }">
          <tbody>
            <tr>
              <td class="font-weight-bold">Membership</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Member_Months ? item.Member_Months : 'N/A' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Member_Months ? recGross.Member_Months : 'N/A' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Member_Months ? recNet.Member_Months : 'N/A' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Member_Months ? recDownstream.Member_Months : 'N/A' }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Funding</td>
              <td
                class="font-weight-bold"
                v-for="item in reconciliationData"
                :key="item.Month"
              >
                {{ item.Funding ? item.Funding : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Funding ? recGross.Funding : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Funding ? recNet.Funding : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Funding ? recDownstream.Funding : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PartAFunding ? item.PartAFunding : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PartAFunding ? recGross.PartAFunding : '$0.00'  }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PartAFunding ? recNet.PartAFunding : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PartAFunding ? recDownstream.PartAFunding : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PartBFunding ? item.PartBFunding : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PartBFunding ? recGross.PartBFunding : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PartBFunding ? recNet.PartBFunding : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PartBFunding ? recDownstream.PartBFunding : '$0.00' }}
              </td>
            </tr>            
            <tr>
              <td class="font-weight-bold">Claims Expense</td>
              <td
                class="font-weight-bold"
                v-for="item in reconciliationData"
                :key="item.Month"
              >
                {{ item.ClaimsExp ? item.ClaimsExp : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.ClaimsExp ? recGross.ClaimsExp : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.ClaimsExp ? recNet.ClaimsExp : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.ClaimsExp ? recDownstream.ClaimsExp : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Part_A ? item.Part_A : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Part_A ? recGross.Part_A : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Part_A ? recNet.Part_A : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Part_A }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Part_B ? item.Part_B : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Part_B ? recGross.Part_B : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Part_B ? recNet.Part_B : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Part_B ? recDownstream.Part_B : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part D</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Part_D ? item.Part_D :'$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Part_D ? recGross.Part_D : '$0.00'  }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Part_D ? recNet.Part_D : '$0.00'  }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Part_D ? recDownstream.Part_D : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PartAExpense ? item.PartAExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PartAExpense ? recGross.PartAExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PartAExpense ? recNet.PartAExpense : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PartAExpense ? recDownstream.PartAExpense : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PartBExpense ? item.PartBExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PartBExpense ? recGross.PartBExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PartBExpense ? recNet.PartBExpense : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PartBExpense ? recDownstream.PartBExpense : '$0.00' }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Cap Expense</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.CapExpense ? item.CapExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.CapExpense ? recGross.CapExpense : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.CapExpense ? recNet.CapExpense: '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.CapExpense ? recDownstream.CapExpense : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">PCP Cap</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PCP_Cap ? item.PCP_Cap : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PCP_Cap ? recGross.PCP_Cap : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PCP_Cap ? recNet.PCP_Cap : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PCP_Cap ? recDownstream.PCP_Cap : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Specialist Cap</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Specialist_Cap }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Specialist_Cap }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Specialist_Cap }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Specialist_Cap }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus' || insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="font-weight-bold">Reinsurance</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Reinsurance ? item.Reinsurance : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Reinsurance ? recGross.Reinsurance : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Reinsurance ? recNet.Reinsurance : '$0.00'  }}
              </td>
              <td class="font-weight-bold">
                <!-- This was originally set as recDownstream.CapExpense, per Chris -->
                {{ recDownstream.Reinsurance ? recDownstream.Reinsurance : '$0.00' }} 
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Specialty Cap</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.SpecialtyCap ? item.SpecialtyCap : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.SpecialtyCap ? recGross.SpecialtyCap : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.SpecialtyCap ? recNet.SpecialtyCap : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.CapExpense ? recDownstream.CapExpense : '$0.00' }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Manual Adj.</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Manual_Adj ? item.Manual_Adj : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Manual_Adj ? recGross.Manual_Adj : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Manual_Adj ? recNet.Manual_Adj : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Manual_Adj ? recDownstream.Manual_Adj : '$0.00'}}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="font-weight-bold">Withheld</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Withheld ? item.Withheld : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Withheld ? recGross.Withheld : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Withheld ? recNet.Withheld : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Withheld ? recDownstream.Withheld : '$0.00' }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">IBNR</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.IBNR ? item.IBNR : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.IBNR ? recGross.IBNR : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{  recNet.IBNR ? recNet.IBNR : '$0.00'}}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.IBNR ? recDownstream.IBNR : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana' || insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="font-weight-bold">Stoploss</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Stoploss ? item.Stoploss : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Stoploss ? recGross.Stoploss : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Stoploss ? recNet.Stoploss : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Stoploss ? recDownstream.Stoploss : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Reserve Fee</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.Reserve ? item.Reserve : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Reserve ? recGross.Reserve : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Reserve ? recNet.Reserve : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Reserve ?  recDownstream.Reserve: '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Plan Share</td>
              <td v-for="item in reconciliationData" :key="item.Month">
                {{ item.PlanShare ? item.PlanShare : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.PlanShare ? recGross.PlanShare : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.PlanShare ? recNet.PlanShare : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.PlanShare ? recDownstream.PlanShare : '$0.00' }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="font-weight-bold">Net</td>
              <td
                class="font-weight-bold"
                v-for="item in reconciliationData"
                :key="item.Month"
              >
                {{ item.Net ? item.Net : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-3'
                    : 'font-weight-bold secondary--text text--darken-3'
                "
              >
                {{ recGross.Net ? recGross.Net : '$0.00' }}
              </td>
              <td
                :class="
                  $vuetify.theme.isDark
                    ? 'font-weight-bold secondary--text text--lighten-5'
                    : 'font-weight-bold secondary--text text--darken-4'
                "
              >
                {{ recNet.Net ? recNet.Net : '$0.00' }}
              </td>
              <td class="font-weight-bold">
                {{ recDownstream.Net ? recDownstream.Net : '$0.00' }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'Reconciliation',
  props: 
  ['organization', 
  'groups', 
  'insurance', 
  'startDate', 
  'endDate', 
  'reportData'
  ],
  data() {
    return {
      search: '',
      load: false,
      pagination: '',
      reconciliationData: [],
      recGross: {},
      recNet: {},
      recDownstream: {},
      expanded: [],
      headers: [],
      pmpm: false,
      cancelSource: null,
    };
  },
  mounted() {
  },
  methods: {
    async getHeaders() {
      this.headers = [];

      if (this.reconciliationData) {
        this.reconciliationData.forEach((month) => {
          this.headers.push({ text: month.Month, value: month.Month });
        });
      }

      this.headers.unshift({ text: 'Metric', value: '', fixed: true }); // first column that will display metric name
      this.headers.push({ text: 'Gross', value: '' }); // first column that will display metric name
      this.headers.push({ text: 'Net', value: '' }); // first column that will display metric name
      this.headers.push({ text: 'Downstream', value: '' }); // first column that will display metric name
    },
    formatCurrency(c) {
      if (c != undefined) { return c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  computed: {
    reportMode() {
      if (this.pmpm == true) {
        return 'PMPM';
      }
      return 'Gross';
    },
    toggleName() {
      if (this.pmpm == true) {
        return 'Gross';
      }
      return 'PMPM';
    }
  },
  watch: {
    async pmpm() {
      this.$emit("pmpm", this.pmpm);
    },
    reportData() {
      const d = this.reportData;
      if (!d || typeof d !== 'object' || Array.isArray(d)) {
        this.reconciliationData = [];
        this.recGross = {};
        this.recNet = {};
        this.recDownstream = {};
        this.getHeaders();
        return;
      }
      this.reconciliationData = d.recData || [];
      this.recGross = d.recGross || {};
      this.recNet = d.recNet || {};
      this.recDownstream = d.recDownstream || {};
      this.getHeaders();
    },
  },
};
</script>
<style scoped>
table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 8;
  background: white;
  border-right: 1px solid #f0f0f0;
}
table > thead > tr > th:nth-child(1) {
  z-index: 9;
}
.theme--dark.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:nth-child(1) {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}
</style>
